import { OnDestroy, Directive } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { ProviderTypeEnum } from 'src/common/constant';

// Why this class? https://www.intertech.com/Blog/angular-best-practice-unsubscribing-rxjs-observables/
@Directive()
export class BaseComponent implements OnDestroy {
  isAdmin = false;
  isViewOnly = false;
  loggedInProviderType: ProviderTypeEnum;
  ProviderTypeEnum = ProviderTypeEnum; // Used to get the enum list available in templates
  DeleteEncounterPolicyYN = false;

  unsubscribe = new Subject<void>();

  constructor(
    protected authenticationService: AuthenticationService
  ) {
    if (this.authenticationService.isLoggedIn()) {
      this.isAdmin = this.authenticationService.userInfo.AuthResult.Instance.IsAdminYN ? true : false;
      this.loggedInProviderType = this.authenticationService.userInfo.AuthUserTypeEnumId;
      this.DeleteEncounterPolicyYN = this.authenticationService.userInfo.DeleteEncounterPolicyYN;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// // Why this class? https://www.intertech.com/Blog/angular-best-practice-unsubscribing-rxjs-observables/
// export abstract class BaseComponent implements OnDestroy {
//   isAdmin = false;
//   unsubscribe = new Subject<void>();

//   authenticationService: AuthenticationService;

//   constructor(
//     injector: Injector
//   ) {
//     this.authenticationService = injector.get(AuthenticationService);
//     this.isAdmin = this.authenticationService.isLoggedIn() && this.authenticationService.userInfo.AuthResult.Instance.IsAdminYN ? true : false;
//   }

//   ngOnDestroy(): void {
//     this.unsubscribe.next();
//     this.unsubscribe.complete();
//   }
// }
